class Style
{
    constructor(code, name)
    {
        this.code = code
        this.name = name
    }

    getName()
    {
        return this.name
    }

    getCode()
    {
        return this.code
    }
}

export default Style

